export default {
    PERSONAL: {
      code: 0,
      name: 'PERSONAL',
    },
    ENTERPRISE: {
      code: 1,
      name: 'ENTERPRISE',
    },
  };
  